// extracted by mini-css-extract-plugin
export default {"bannerHeader":"style_bannerHeader__C3FI8","directorsSection":"style_directorsSection__OFLjK"};